import React from "react";
import {
  chartTickPriceFormatWrapper,
  priceDecoratorWrapper,
} from "../../../../styles/cell-decorators";
import ChartComponent from "../../../../components/dashboard-components/chart-component/chart-component";

export default function CustomerPricingChartComponent(props) {
  const { currency } = props;
  return (
    <ChartComponent
      {...props}
      title={"Your Average Selling Price"}
      currentKey={"currentAvgSellingPrice"}
      previousKey={"previousAvgSellingPrice"}
      changeKey={"avgSellingPriceDiff"}
      taglineSubject={"Your average selling price"}
      legendName={"Average Selling Price"}
      yTickFormat={chartTickPriceFormatWrapper(currency)}
      valueDecorator={priceDecoratorWrapper(
        props.currency,
        "average_selling_price_"
      )}
    />
  );
}
